import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import ScrollToTop from "./components/ui/ScrollToTop.jsx";

import HomePage from "./pages/HomePage.jsx";
import Header from "./components/Header.jsx";
import Footer from "./components/Footer.jsx";
// import AboutPage from "./pages/AboutPage.jsx";
// import ContactPage from "./pages/ContactPage.jsx";
import PaletteDemoPage from "./pages/PaletteDemoPage.jsx";
import BioLngTransportPage from "./pages/BioLngTransportPage.jsx";

function App() {
  return (
    <Router>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/bio-lng-in-transport" element={<BioLngTransportPage />} />
          {/* <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} /> */}
          <Route path="/palette" element={<PaletteDemoPage />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
        <Footer />
    </Router>
  );
}

export default App;
